import {Injectable} from '@angular/core';

import {Util} from '../app/util';

import {LogadoService} from "../providers/logado-service";
import {
    ENUM,
    TAction,
    TProdutoTipo,
    TGaleriaTipo,
    TProfileTeam,
    TUsuarioRole,
    TMeritumAuth,
    TUsuarioDono,
} from "../app/enum";
import {CONFIG} from "../app/config";

import {Observable, Observer} from "rxjs";
import {MessageService} from "../providers/message-service";
import {HotspotService} from "../providers/hotspot-service";

@Injectable()
export class HotspotRepository {

    ENUM: any = ENUM;
    
    constructor(public util: Util,
                public logadoService: LogadoService,
                public hotspotService: HotspotService, public messageService: MessageService) {

    }

    usuarioFake(hotspotID: number, profile, editado) : any {
        
        let usuarioRole = (profile.ProfileZito ? TUsuarioRole.urCEO : TUsuarioRole.urDiretor);

        let usuario: any = {};
        usuario.Profile = profile;
        usuario.Editado = editado;
        usuario.Departa = CONFIG.departa;
        usuario.HotspotID = hotspotID;
        usuario.UsuarioRole = usuarioRole;
        usuario.UsuarioDono = TUsuarioDono.udADM;
        usuario.UsuarioCode = '';
        usuario.UsuarioFree = 0;
        usuario.UsuarioPage = false;
        usuario.UsuarioFatu = false;

        this.usuarioNovo(usuario, null);
        this.usuarioFlag([usuario], profile.ProfileID, profile.ProfileTeam);

        return usuario;

    }

    usuarioNull(hotspotID: number, profile: any, editado: any): any {

        let hotspotNovo = (hotspotID == 0);
        let usuarioRole = (hotspotNovo ? TUsuarioRole.urCEO : TUsuarioRole.urNenhum);
        let usuarioDono = (hotspotNovo ? TUsuarioDono.udERP : TUsuarioDono.udPDV);

        let usuario: any = {};
        usuario.Profile = profile;
        usuario.Editado = editado;
        usuario.Departa = (hotspotNovo ? CONFIG.departa : null);
        usuario.HotspotID = hotspotID;
        usuario.UsuarioRole = usuarioRole;
        usuario.UsuarioDono = usuarioDono;
        usuario.UsuarioCode = ''; //(Math.random() + '').substring(2, 5);
        usuario.UsuarioFree = 0;
        usuario.UsuarioPage = (usuarioRole == TUsuarioRole.urCEO);
        usuario.UsuarioFatu = false;
        usuario.UsuarioCria = this.util.dateToStr(this.util.dateHoje(), true);

        this.usuarioNovo(usuario, null);
        this.usuarioFlag([usuario], profile.ProfileID, profile.ProfileTeam);

        return usuario;

    }

    usuarioNovo(usuario, operador: null | 'caxa' | 'sale') {

        let role = usuario.UsuarioRole
    
        let valueA = (role <= TUsuarioRole.urVP) ? 1 : 0
        let valueD = (role <= TUsuarioRole.urDiretor) ? 1 : 0
        let valueG = (role <= TUsuarioRole.urGestor) ? 1 : 0


        //CEO & VP
        usuario.UsuarioOlho = valueA
        usuario.UsuarioOlhe = (valueA ? false : valueD)
        usuario.UsuarioMail = valueA
        usuario.UsuarioPara = (valueA ? usuario.UsuarioPara : '')

        //Gestão
        usuario.UsuarioCoin = valueD
        usuario.UsuarioGera = valueD
        usuario.UsuarioNota = valueD
        usuario.UsuarioBank = valueD

        //Item
        usuario.UsuarioMenu = valueD
        usuario.UsuarioStok = valueD
        usuario.UsuarioItem = valueD
      //usuario.UsuarioRoad = valueD
        usuario.UsuarioFoto = valueD
        usuario.UsuarioMark = valueD
        usuario.UsuarioCard = valueD
        usuario.UsuarioSeal = valueD
        
        //Ação
      //usuario.UsuarioHora = valueD
      //usuario.UsuarioClub = valueD
      //usuario.UsuarioChat = valueD


        //usuario.UsuarioCode = ;


        //Venda
        usuario.UsuarioSale = (usuario.UsuarioDono == TUsuarioDono.udPDV && operador == 'sale' ? 1 : valueG)
        usuario.UsuarioGorj = valueG
        usuario.UsuarioMove = valueD
        usuario.UsuarioDisc = valueD
        
        //Stock
        usuario.UsuarioRepo = valueG
        usuario.UsuarioCanc = valueD

        //Caixa
        usuario.UsuarioCaxa = (usuario.UsuarioDono == TUsuarioDono.udPDV && operador == 'caxa' ? 1 : valueG)
        usuario.UsuarioDesp = valueD
        usuario.UsuarioEsto = valueD
        usuario.UsuarioBlod = valueD

        //Porta
        usuario.UsuarioGoin = (usuario.UsuarioDono == TUsuarioDono.udPDV && operador == 'caxa' ? 1 : valueG)
        usuario.UsuarioSair = (usuario.UsuarioDono == TUsuarioDono.udPDV && operador == 'caxa' ? 1 : valueG)
        usuario.UsuarioMemo = valueG
        usuario.UsuarioLock = valueG
        usuario.UsuarioDoor = valueD
        usuario.UsuarioPend = valueD
        

        //Publish
        //usuario.UsuarioPage = usuario.UsuarioPage
        //usuario.UsuarioHtml = usuario.UsuarioHtml

    }

    usuarioFlag(usuarios, profileID?, profileTeam: TProfileTeam = TProfileTeam.mkNenhum): any {

        let pos: number = -1;

        usuarios.forEach((user, index) => {

            //UserFlag - Se tem permissao user local ou de franquiados
            for (var field in user) {

                if (field.slice(0, 7) != 'Usuario' || field == 'UsuarioRole' || field == 'UsuarioDono') continue;
                let flagname = 'Flag' + field.slice(7, 99);
                user[flagname] = (user[field] > 0);

            }

            //Flag Hotspot - Memberteam e Filiados
            user.FlagZito = (profileTeam >= TProfileTeam.mkManager && user.Profile.ProfileID == CONFIG.data.ellzitoID);
            user.FlagTeam = (profileTeam >= TProfileTeam.mkManager);
        
            user.FlagPreside = (                 (user.UsuarioRole >= TUsuarioRole.urCEO && user.UsuarioRole <= TUsuarioRole.urVP));
            user.FlagDiretor = (user.FlagTeam || (user.UsuarioRole >= TUsuarioRole.urCEO && user.UsuarioRole <= TUsuarioRole.urDiretor));
            user.FlagGerente = (user.FlagTeam || (user.UsuarioRole >= TUsuarioRole.urCEO && user.UsuarioRole <= TUsuarioRole.urGestor));
            if (user.Profile.ProfileID == profileID) pos = index;

        });

        return usuarios[pos];

    }

    usuarioNote(usuario): string {

        if (usuario.UsuarioRole < TUsuarioRole.urOperador) return this.ENUM.usuarioRule(false, usuario.Departa, usuario.UsuarioRole);
        let boss = (usuario.UsuarioDisc || usuario.UsuarioCanc || usuario.UsuarioDesp || usuario.UsuarioEsto || usuario.UsuarioBlod || usuario.UsuarioPend || usuario.UsuarioDoor);
        if (usuario.UsuarioCaxa) return (boss ? 'Chefe de Caixa' : 'Caixa');
        if (usuario.UsuarioGoin) return 'Checkin';
        if (usuario.UsuarioRepo) return 'Repositor';
        if (usuario.UsuarioSale) return (boss ? 'Chefe de Bar' : 'Barman');
        return '';

    }

    galeriaView(hotspotID: number, galeriaID: number, galeriaTipo: TGaleriaTipo) {

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.galeria(TAction.acLoad, hotspotID, galeriaID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    let keyname = TGaleriaTipo[galeriaTipo].substring(2, 10) + 's';
                    let galerias = data.Galerias[keyname];

                    if (galeriaTipo == TGaleriaTipo.gtPlace) this.util.photosee(galerias);
                    if (galeriaTipo == TGaleriaTipo.gtPhoto) this.util.photosee(galerias);
                    if (galeriaTipo == TGaleriaTipo.gtVideo) this.util.moviesee(galerias);
                    if (galeriaTipo == TGaleriaTipo.gtMusic) this.util.musicsee(galerias);
                    if (galeriaTipo == TGaleriaTipo.gtBanner) return;
                    if (galeriaTipo == TGaleriaTipo.gtScreen) return;
                    if (galeriaTipo == TGaleriaTipo.gtNotice) return;
                    if (galeriaTipo == TGaleriaTipo.gtAlerta) return;

                },
                erro => {

                    this.util.alertResult(erro);

                }
            );

    }

    meritumArray(rootspot, produtoTipo: TProdutoTipo, flagCard: boolean = true, flagSeal: boolean = true): Array<any> {

        let keyroot = [];
        let array = [];

        flagCard = (flagCard && (produtoTipo == TProdutoTipo.ptNone || produtoTipo == TProdutoTipo.ptCard));
        flagSeal = (flagSeal && (produtoTipo == TProdutoTipo.ptNone || produtoTipo == TProdutoTipo.ptSeal));

        if (flagCard) keyroot.push(TProdutoTipo.ptCard);
        if (flagSeal) keyroot.push(TProdutoTipo.ptSeal);

        rootspot.Meritums.forEach(mr => {

            if (mr.MeritumAuth > TMeritumAuth.maNone) {
    
                let qtdeCard = 0;
                let qtdeSeal = 0;
                keyroot.forEach(bxTipo => {
    
                    if (flagCard) qtdeCard += this.util.jsCount(mr.BlendedArray, ['ProdutoCards', 'ProdutoID']);
                    if (flagSeal) qtdeSeal += this.util.jsCount(mr.BlendedArray, ['ProdutoSeals', 'ProdutoID']);
    
                });
    
                if (qtdeCard + qtdeSeal > 0) array.push(mr);
        
            }

        });

        return array;

    }



    followe(event: any, hotspot: any, profileID: number): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            //Inverte para enviar o click contrário
            let followeBell = !hotspot.Followe.FolloweBell;

            let loading = this.util.loadingDots();
            if (!event) loading.present();

            let json = this.util.deepCopy(hotspot.Followe);
            json.FolloweBell = followeBell;

            this.hotspotService.followe(TAction.acBell, hotspot.HotspotID, profileID, json)
                .finally(() => {
                    if (event) event.cancelLoader();
                    loading.dismiss();
                })
                .subscribe(data => {

                    hotspot.Followe.FolloweQtde = hotspot.Followe.FolloweQtde + (followeBell ? 1 : -1);
                    hotspot.Followe.FolloweBell = followeBell;

                    this.messageService.get('follow.changed.contra').next(hotspot);

                    observer.next(data);
                    observer.complete();

                }, erro => {

                    this.util.alertResult(erro);

                    observer.error(erro);
                    observer.complete();

                });

        });

    }


    subscribeFolloweChanged(objectArray: Array<any> | Object): Observable<any> {

        return Observable.create((observer: Observer<any>) => {

            this.messageService.get('follow.changed.contra')
                .subscribe(data => {

                    let array: any[] = (objectArray instanceof Array) ? objectArray : [objectArray];
                    let hotspot = array.find(HS => (HS.HotspotID == data.HotspotID));

                    if (hotspot) {
                        hotspot.Followe.FolloweBell = data.Followe.FolloweBell;
                        hotspot.Followe.FolloweQtde = data.Followe.FolloweQtde;
                    }

                    observer.next(data);
                    observer.complete();

                }, erro => {

                    observer.error(erro);
                    observer.complete();

                });

        });

    }



}



// WEBPACK FOOTER //
// ./src/repositories/hotspot-repository.ts